import { AuthClient, ClientConfig, UserClient } from 'src/lib/itaptec/http_client/src'
import { authTokenStorage } from '../utils/localStorage'
import axios from 'axios'
import { AuthorizationResponse } from 'src/types/user/authData'
import { UserViewDTO } from 'src/types/user/userData'

let axiosInstanceHeaders: any
const tokenAutorizacion = authTokenStorage.get()

/* Los headers usan "common" para que se aplique para todas las request. */
if (tokenAutorizacion != null) {
    axiosInstanceHeaders = {
        common: { Authorization: 'Bearer ' + tokenAutorizacion }
    }
}

/* Si se desea configurar para que consuma la api de forma local, dentro de public/configuration.js
   setear en domain localhost:44341 */
const axiosInstance = axios.create({
    baseURL: `${window.API_PROTOCOL}://${window.API_DOMAIN}/api/${window.API_VERSION}/`,
    timeout: window.API_TIMEOUT,
    headers: axiosInstanceHeaders
})

export function refreshToken(newAuthToken: string) {
    axiosInstanceHeaders = {
        common: { Authorization: 'Bearer ' + newAuthToken }
    }
    axiosInstance.defaults.headers = axiosInstanceHeaders
}

const config: ClientConfig = {}

export const apiAuth = new AuthClient<AuthorizationResponse>(axiosInstance, config)

export const apiUsers = new UserClient<UserViewDTO>(axiosInstance, config)
